import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	errorInvalidOfferCode: {
		id: 'dtcPartnership.eligibilityEnrollment.errorInvalidOfferCode',
		defaultMessage:
			'This offer code is not valid. Please check for any accidental typos made before trying again. If you are still experiencing trouble, please reach out to {partnerName} for assistance.',
		description: "Indicates the user's offer code is invalid",
	},
	errorUsedOfferCode: {
		id: 'dtcPartnership.eligibilityEnrollment.errorUsedOfferCode',
		defaultMessage:
			"This offer code has already been redeemed. If you think this has been a mistake, please contact Calm's Support team <supportLink>here</supportLink>",
		description: "Indicates the user's offer code is invalid",
	},
	offercodeCTA: {
		id: 'dtcPartnership.eligibility.descriptor.offerCodeCTA',
		defaultMessage: 'Enter your offer code',
		description: 'the phrase Enter Your Offer Code',
	},
	offercode: {
		id: 'dtcPartnership.eligibility.descriptor.offerCode',
		defaultMessage: 'Offer Code',
		description: 'the term Offer Code',
	},
});
